export function uriStringify(data:any):string {
  return encodeURIComponent(JSON.stringify(data));
}